import React from 'react'

const SvgIconClock = (props) => (
  <svg viewBox="0 0 20 20" {...props}>
    <g fill="currentColor">
      <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18.25c-4.542 0-8.25-3.688-8.25-8.25 0-4.563 3.708-8.25 8.25-8.25s8.25 3.708 8.25 8.25-3.708 8.25-8.25 8.25z" />
      <path d="M10.756 9.583V4.868a.879.879 0 0 0-1.756 0v5.066a.87.87 0 0 0 .25.62l4.245 4.198a.89.89 0 0 0 .627.248.89.89 0 0 0 .627-.248c.335-.33.335-.89 0-1.24l-3.993-3.93z" />
    </g>
  </svg>
)

export default SvgIconClock
